import React from 'react';
import DarkMarketingPage from '../Shared/DarkMarketingPage';
import Email from '../../../images/marketing/emailHosting/email.png';
import EmailFirst from '../../../images/marketing/emailHosting/emailFirst.jpg';
import EmailSecond from '../../../images/marketing/emailHosting/emailSecond.jpg';
import PrivacyTip from '../../../images/marketing/emailHosting/privacyTip.png';

const sections = [
  {
    label: 'EMAIL FEATURE',
    icon: Email,
    title: 'Easy Communication',
    description:
      "Make sure you don't miss an important opportunity. Our email system helps you get your business started all in one place. Just a couple of clicks and your email is setup.",
    link: '/emailhosting',
    image: EmailFirst,
  },
  {
    label: 'PRIVACY PROTECTION',
    icon: PrivacyTip,
    title: 'Simple Setup',
    description:
      "We make sure you aren't bothered by unrelated emails. We build our email system from the ground up so you can trust what we offer.",
    link: '/emailhosting',
    image: EmailSecond,
    reverse: true,
  },
];

const quickTags = [
  'Fast Inbox Setup',
  'Hosted Mail',
  'Privacy Protection',
  'Business Communication',
  'Easy Management',
  'Secure Defaults',
];

const EmailHostingContent = ({ history }) => (
  <DarkMarketingPage
    history={history}
    title="EditPage Email Hosting"
    subtitle="EditPage offers email as an option together with your website."
    sections={sections}
    quickTags={quickTags}
  />
);

export default EmailHostingContent;
